var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm.model}},[_c('v-autocomplete',{attrs:{"hint":_vm.hint,"persistent-hint":"","multiple":"","search-input":_vm.search,"disabled":_vm.disabled,"items":_vm.selectItems,"rules":_vm.computedRules,"label":_vm.label,"item-value":_vm.itemValue,"item-text":_vm.itemText,"clearable":""},on:{"input":function($event){return _vm.updateMulti()},"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n\t\t\t"+_vm._s((!data.item
					? ''
					: !_vm.itemText
					? data.item
					: typeof _vm.itemText === 'function'
					? _vm.itemText(data.item)
					: data.item[_vm.itemText]) + (data.index !== _vm.model.length - 1 ? ',' : ''))+"\n\t\t")]}},{key:"item",fn:function(data){return [_c('span',{class:{ 'is-separator': _vm.isSeparator(data.item) }},[_vm._v("\n\t\t\t\t"+_vm._s(!data.item
						? ''
						: !_vm.itemText
						? data.item
						: typeof _vm.itemText === 'function'
						? _vm.itemText(data.item)
						: data.item[_vm.itemText])+"\n\t\t\t")])]}}]),model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3c58ad6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/inputs/multiSelectInput.vue
// module id = null
// module chunks = 